import { IProductListService } from "../../../js/types/app/service/IProductListService";
import { utilsModule } from "../utils-module";

utilsModule.service('productList', function () {
  let self: IProductListService = this;
  
  self.list = null;

  self.getAmountInStock = function(productId) {
    
    var product = this.list.filter(function(product){
      return product.id == productId;
    });

    product = product.length > 0 ? product[0] : null;

    if (product == null) {
      return null;
    }

    return product.amountInStock;
  }
})
